<script>
    import {onMount} from "svelte";
    import Tags from "../Components/Tags.svelte";
    import TinymceField from "./CustomFields/tinymceField.svelte";
    import RiskSelect from './CustomFields/RiskSelect.svelte';
    import ReferencesField from "./CustomFields/ReferencesField.svelte";
    import CustomTags from "./CustomFields/CustomTags.svelte";

    export let label = "";
    export let type = "text";
    export let value = type == "checkbox" ? false : "";
    export let placeholder = "";
    export let name;
    export let dflt = undefined;
    export let required = false;
    export let autoComplete = [];
    export let mce_opts = {};
    export let component = null;
    export let componentProps = {};

    export let fieldProps = {};

    export let field_class = "";
    export let multiple = false;

    export let preq_default = undefined;
    export let preq_value = undefined;

    let fileinput;
    let filevalue;

    export let choices = {};

    export let options = [];

    let filename = "";

    function handle_file(filevalue) {
        if (!fileinput)
            return;

        filename = "";

        for (let file of fileinput.files) {
            filename += file.name
        }

        value = fileinput.files;

        return;
    }

    function check_default(preq_value) {

        if (preq_default && Object.values(preq_default).includes(value)) {
            value = preq_default[preq_value];
        }
    }

    $: handle_file(filevalue);

    onMount(async () => {
        if (dflt != undefined && !value) {
            value = dflt;
        } else if (!value && type == "select" && !multiple && required) {
            value = choices.static[0].value != undefined ? choices.static[0].value : choices.static[0];
        } else if (value == "" && type == "checkbox") {
            value = false;
        }

        if (type == "select") {
            if (choices.static) {
                options = choices.static
            }
        }
    })

    export let errors = [];

    $: check_default(preq_value);
</script>

{#if type != "file"}
    <div class="field">
        {#if label}
            <label for={name} class="label {field_class}">
                {#if type == "checkbox"}
                    <input id={name} name={name} type="checkbox" bind:checked={value}>
                {/if}
                {label}
            </label>
        {/if}
        <div class="control">
            {#if type == "text"}
                <input class="input {errors[name] ? 'is-danger' : ''} {field_class}" type="text" {placeholder} bind:value={value} {name} {required} {...fieldProps} on:change on:blur>
            {:else if type == "number"}
                <input class="input {errors[name] ? 'is-danger' : ''} {field_class}" type="number" {placeholder} bind:value={value} {name} {required} {...fieldProps} on:change on:blur>
            {:else if type == "password"}
            <input class="input {errors[name] ? 'is-danger' : ''} {field_class}" type="password" {placeholder} bind:value={value} {name} {required} {...fieldProps} on:change on:blur>
            {:else if type == "email"}
                <input class="input {errors[name] ? 'is-danger' : ''} {field_class}" type="email" {placeholder} bind:value={value} {name} {required} {...fieldProps} on:change on:blur>
            {:else if type=="tel"}
                <input class="input {errors[name] ? 'is-danger' : ''} {field_class}" type="tel" {placeholder} bind:value={value} {name} {required} {...fieldProps} on:change on:blur>
            {:else if type=="date"}
                <input class="input {errors[name] ? 'is-danger' : ''} {field_class}" type="date" {placeholder} bind:value={value} {name} {required} {...fieldProps} on:change on:blur>
            {:else if type=="color"}
                <input class="input {errors[name] ? 'is-danger' : ''} {field_class}" type="color" {placeholder} bind:value={value} {name} {required} {...fieldProps} on:change on:blur>
            {:else if type == "tags"}
                <Tags bind:tags={value} {name} {placeholder} {autoComplete} addKeys={[9,13]} allowBlur={true}></Tags>
            {:else if type == "customTags"}
                <CustomTags bind:value  {name} {options} />
            {:else if type=="select"}
                {#if multiple}
                    <div class="select is-fullwidth {field_class} is-multiple">
                        <select {name} {required} bind:value={value} multiple on:change on:blur {...fieldProps}>
                            {#if options.groups}
                                {#each options.groups as group}
                                    <optgroup label={group.name}>
                                        {#each group.options as option}
                                            <option value={option.value != undefined ? option.value : option}>
                                                {option.label || (option.value != undefined ? option.value : option)}
                                            </option>
                                        {/each}
                                    </optgroup>
                                {/each}
                            {:else}
                                {#each options as option}
                                    <option value={option.value != undefined ? option.value : option}>
                                        {option.label || (option.value != undefined ? option.value : option)}
                                    </option>
                                {/each}
                            {/if}
                        </select>
                    </div>
                {:else}
                    <div class="select is-fullwidth {field_class}">
                        <select {name} {required} bind:value={value} on:change on:blur>
                            {#if !required}
                                <option value=""></option>
                            {/if}
                            {#if options.groups}
                                {#each options.groups as group}
                                    <optgroup label={group.name}>
                                        {#each group.options as option}
                                            <option value={option.value != undefined ? option.value : option}>
                                                {option.label || (option.value != undefined ? option.value : option)}
                                            </option>
                                        {/each}
                                    </optgroup>
                                {/each}
                            {:else}
                                {#each options as option}
                                    <option value={option.value != undefined ? option.value : option}>
                                        {option.label || (option.value != undefined ? option.value : option)}
                                    </option>
                                {/each}
                            {/if}
                        </select>
                    </div>
                {/if}
            {:else if type == "risk"}
                <RiskSelect {name} {required} bind:value={value} on:change on:blur {multiple} {field_class}></RiskSelect>
            {:else if type == "references"}
                <ReferencesField {name} bind:value="{value}" on:change />
            {:else if type=="textarea"}
                <textarea class="textarea" {placeholder} bind:value={value} {name} {required} on:change on:blur {...fieldProps}></textarea>
            {:else if type == "tinymce"}
                <TinymceField bind:value={value} {mce_opts}></TinymceField>
            {:else if type == "custom"}
                <svelte:component this={component} {...componentProps} bind:value={value} />
            {/if}
        </div>
        {#if errors[name]}
            <p class="help is-danger">{errors[name]}</p>
        {/if}
    </div>
{:else}
    {#if label}
        <label for={name} class="label">{label}</label>
    {/if}
    <div class="file has-name">
    <label class="file-label">
        <input class="file-input" type="file" name={name} bind:value={filevalue} bind:this={fileinput} {required} on:change {...fieldProps}>
        <span class="file-cta">
        <span class="file-icon">
            <i class="fas fa-upload"></i>
        </span>
        <span class="file-label">
            Choose a file…
        </span>
        </span>
        <span class="file-name">
            {filename}
        </span>
    </label>
    </div>
{/if}

<style>
    .file-cta, .file-name, .file-cta:hover {
        color: #4a4a4a !important;
        background-color: white;
    }
</style>